import { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';

import Button from '@Hotels-at-Home/hah-fe-core/dist/components/Button';

const BeddingSection = (): ReactElement => {
  const { t } = useTranslation('', { keyPrefix: '$pages.$home.$beddingSection' });
  const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });
  const { t: tLink } = useTranslation('', { keyPrefix: '$local.$homePageLinks.$bedding' });

  return (
    <section className="base-section bedding-section">
      <div className="item">
        <a className="bedding-product-wrap hover-btn-animation" href={tLink('beddingMain')}>
          <div className="bedding-comfort">
            <div className="text-container">
              <h2>{t('title')}</h2>
              <p>{t('copy')}</p>
            </div>
            <Button
              className="base-btn bg-red"
              noTabbing
              ariaLabel={`${tButton('shopNow')}: ${t('bedding')}`}
            >
              {t('bedding')}
            </Button>
          </div>
        </a>
      </div>
      <div className="item">
        <a className="bedding-product-wrap hover-btn-animation" href={tLink('sheets')}>
          <picture>
            <img
              src="/images/homePage/beddingSection/sheu-sheets.webp"
              alt={t('sheets')}
              width={755}
              height={787}
              loading="eager"
              decoding="async"
              fetchPriority="low"
            />
          </picture>
          <Button
            variant="txt"
            className="base-btn bg-transparent"
            noTabbing
            ariaLabel={`${tButton('shopNow')}: ${t('sheets')}`}
          >
            <h3>{t('sheets')}</h3>
          </Button>
        </a>
      </div>
      <div className="item">
        <a className="bedding-product-wrap hover-btn-animation" href={tLink('pillows')}>
          <picture>
            <img
              src="/images/homePage/beddingSection/sheu-pillows.webp"
              alt={t('pillows')}
              width={755}
              height={787}
              loading="lazy"
              decoding="async"
              fetchPriority="low"
            />
          </picture>
          <Button
            variant="txt"
            className="base-btn bg-transparent"
            ariaLabel={`${tButton('shopNow')}: ${t('pillows')}`}
          >
            <h3>{t('pillows')}</h3>
          </Button>
        </a>
      </div>
      <div className="item">
        <a className="bedding-product-wrap hover-btn-animation" href={tLink('bedding')}>
          <picture>
            <img
              src="/images/homePage/beddingSection/sheu-beddings.webp"
              alt={t('bedding')}
              width={755}
              height={787}
              loading="lazy"
              decoding="async"
              fetchPriority="low"
            />
          </picture>
          <Button
            variant="txt"
            className="base-btn bg-transparent"
            ariaLabel={`${tButton('shopNow')}: ${t('bedding')}`}
          >
            <h3>{t('bedding')}</h3>
          </Button>
        </a>
      </div>
    </section>
  );
};

export default BeddingSection;
